import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '@src/service/axios';
import { toast } from 'react-toastify';

export const getUser = createAsyncThunk('userSlice/getUser', async () => {
    try {
        let response = await axios.get('/user', {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return Promise.resolve(response.data.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const createUser = createAsyncThunk('userSlice/createUser', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/user', data, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: false
        });
        toast.success(response?.data?.message || 'User created successfully.');
        dispatch(getUser());

        return Promise.resolve(response.data.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updateUser = createAsyncThunk('userSlice/updateUser', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/user/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: false
        });
        toast.success(response?.data?.message || 'User updated successfully.');
        dispatch(getUser());

        return Promise.resolve(response.data.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getUserById = createAsyncThunk('userSlice/getUserById', async (id) => {
    try {
        let response = await axios.get('/user/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
            // loader: true
        });

        return Promise.resolve(response.data.data);
    } catch (err) {
        toast.error(err.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const deleteUser = createAsyncThunk('userSlice/deleteUser', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/user/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: false
        });
        toast.success(response?.data?.message || 'User deleted successfully');
        dispatch(getUser());

        return Promise.resolve(response.data.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updateStatus = createAsyncThunk('userSlice/updateStatus', async (id, { dispatch }) => {
    try {
        let response = await axios.put('/user/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: true
        });
        toast.success(response?.data?.message || 'Status updated successfully.');
        dispatch(getUser());

        return Promise.resolve(response.data.data);
    } catch (err) {
        toast.err(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});
///** User Password Reset Api

export const updateUserPassword = createAsyncThunk('userSlice/updateUserPassword', async (data) => {
    try {
        let response = await axios.put('/admin/user-reset-password/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: false
        });
        toast.success(response?.data?.message || 'User Password reset successfully!');
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const userLogin = createAsyncThunk('userSlice/userLogin', async (id) => {
    try {
        let response = await axios.get('/mock-user/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const userSlice = createSlice({
    name: 'userSlice',
    initialState: {
        data: [],
        options: [],
        selectedUser: {}
    },
    reducers: {
        // handleSelectedUser: (state, action) => {
        //     state.selectedUser = action.payload;
        // },
        removeSelectedUser: (state, action) => {
            state.selectedUser = {};
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getUser.fulfilled, (state, action) => {
            state.data = action.payload;
            return;
        });
        builder.addCase(getUserById.fulfilled, (state, action) => {
            state.selectedUser = action.payload;
            return;
        });
    }
});

export const { removeSelectedUser } = userSlice.actions;

export default userSlice.reducer;
